import en from './en.json'
import es from './es.json'
const defaultLocales = {
  en,
  es
}

export default defaultLocales
